var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('radar-chart',{ref:"chart",staticClass:"pivots-chart",class:{'pivots-chart--small-device': _vm.isSmallDevice},attrs:{"params":_vm.radarChartParams}})}
var staticRenderFns = []

export { render, staticRenderFns }